// extracted by mini-css-extract-plugin
export default {"container":"NetworkElementsSFTPForm_container__zW6tg"};